// create a component for update server setting based on model ServerSetting
import { useActionState, useEffect } from "react";
import FormBody from "../../../../components/form-body";
import Input from "../../../../components/input";
import Label from "../../../../components/label";
import FormActions from "../../../../components/form-actions";
import { Button } from "../../../../components/button";
import { ServerSetting } from "../../../../models";
import { updateServerSetting } from "../actions";
import { useNavigate } from "react-router-dom";

export default function ServerSettingForm({
  serverSetting,
}: {
  serverSetting: ServerSetting;
}) {
    const initialSate={
        message: "",
        success: false,
        defaultValues: {
          emailFromAddress: serverSetting.emailFromAddress,
          emailFromName: serverSetting.emailFromName,
        },        
    }
  const navigate = useNavigate();
  const [state, formAction, isPending] = useActionState(
    updateServerSetting,
    initialSate
  );
  useEffect(() => {
    if (state?.success) navigate(`/admin/server-settings?reload=${Date.now()}`);
  }, [state]);
  return (
    <form className="w-full max-w-3xl text-left py-8" action={formAction}>
      <FormBody>
        <div className="">
          <Label>Email From Address</Label>
          <Input
            name="emailFromAddress"
            type="text"
            defaultValue={state.defaultValues.emailFromAddress}
          ></Input>
        </div>
        <div className="mt-3">
          <Label>Email From Name</Label>
          <Input
            name="emailFromName"
            type="text"
            defaultValue={state.defaultValues.emailFromName}
          ></Input>
        </div>
        <FormActions>
          <Button
            type="submit"
            disabled={isPending}
            className="min-w-[90px]"
            loading={isPending}
          >
            Save
          </Button>
        </FormActions>
      </FormBody>
    </form>
  );
}
